const compareVersion = (v1 = '0', v2 = '0') => {
  const arr1 = v1.split('.');
  const arr2 = v2.split('.');
  const len = Math.max(arr1.length, arr2.length);

  while (arr1.length < len) {
    arr1.push('0');
  }

  while (arr2.length < len) {
    arr2.push('0');
  }

  for (let i = 0; i < len; i++) {
    const num1 = parseInt(arr1[i]);
    const num2 = parseInt(arr2[i]);
    if (num1 > num2) {
      return 1;
    } else if (num1 < num2) {
      return -1;
    }
  }

  return 0;
}

const isIOS = (ua = '') => {
  const v = /iPad|iPhone|iPod|iOS/gi.test(ua) && !window.MSStream;
  return v;
}

export const isWX = (ua = '') => {
  return ua.indexOf('MicroMessenger') > -1 || ua.indexOf('MMWEBSDK') > -1;
}

export const getIOSVersion = (ua = '') => {
  if (isIOS(ua)) {
    const v = ua.match(/OS (\d+)_(\d+)_?(\d+)?/);
    return v[1] || '';
  }
  return '';
}

export const checkOpenAppByBroswer = () => {
  const ua = window.navigator.userAgent;
  const iosVersion = getIOSVersion(ua);
  if (isWX(ua)) {
    return iosVersion ? compareVersion(iosVersion, '17.0.0') >= 0 : true;
  }
  return false;
}

export const checkOpenAppByBroswerInIos = () => {
    const ua = window.navigator.userAgent;
    const iosVersion = getIOSVersion(ua);
    if (!isWX(ua)) {
      return iosVersion && compareVersion(iosVersion, '17.0.0') >= 0
    }
    return false;
  }
